// src/pages/ContentMappingReport.js
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { lessonAnalysisAPI } from '../services/api';

const ContentMappingReport = () => {
    const { lessonPlanId } = useParams();
    const [analysis, setAnalysis] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchAnalysis = async () => {
            try {
                const res = await lessonAnalysisAPI.getStatus(lessonPlanId);
                setAnalysis(res.data);
            } catch (err) {
                setError('Failed to fetch content analysis.');
            } finally {
                setLoading(false);
            }
        };
        fetchAnalysis();
    }, [lessonPlanId]);

    if (loading) return <p>Loading content mapping...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    if (!analysis || analysis.status !== 'COMPLETED') {
        return (
            <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
                <Link to={`/lesson-plan/${lessonPlanId}`}>← Back to Lesson Plan</Link>
                <h1>Content Mapping Report</h1>
                <p>The lesson content analysis is not yet complete. Please return to the lesson plan and run the analysis.</p>
                <p>Current Status: <strong>{analysis?.status || 'NOT FOUND'}</strong></p>
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
            <Link to={`/lesson-plan/${lessonPlanId}`}>← Back to Lesson Plan</Link>
            <h1>Content Mapping Report</h1>

            <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', background: '#f9f9f9', padding: '15px', borderRadius: '5px' }}>
                {analysis.fullContent}
            </pre>
        </div>
    );
};

export default ContentMappingReport;